var _defs, _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFMobileLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba0cb372-455c-4c58-9fe2-81142d4c0faf",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 94.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.af6c39ed-0ad9-4311-bbdd-b260d5677033{fill:none;stroke:#777;stroke-width:0.75px;}.aac06aff-d2f8-40b1-8c6d-5437eb5166ce{fill:#777; stroke-width:0.75px;}\n"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "ed94499a-bc2a-46f8-aa71-d8dfaa47affd",
    "data-name": "Line 9",
    className: "af6c39ed-0ad9-4311-bbdd-b260d5677033 svg-line",
    x1: 4.5,
    x2: 4.5,
    y2: 85.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a1765eb4-ccad-4f4e-a2b9-97e3e128dc25",
    "data-name": "Ellipse 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aac06aff-d2f8-40b1-8c6d-5437eb5166ce svg-line",
    cx: 4.5,
    cy: 90,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "af6c39ed-0ad9-4311-bbdd-b260d5677033",
    cx: 4.5,
    cy: 90,
    r: 4.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMobileLine);
export default __webpack_public_path__ + "static/media/F-Mobile-Line.8c19a451d6d10d421721f63ea1e9cefa.svg";
export { ForwardRef as ReactComponent };